var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wp-debug-tool" },
    [
      _c(
        "a-descriptions",
        { attrs: { title: "", layout: "vertical", bordered: "" } },
        [
          _c(
            "a-descriptions-item",
            { attrs: { label: _vm.$t("whatsapp.product") } },
            [_vm._v(" " + _vm._s(_vm.getPlanName()))]
          ),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: _vm.$t("whatsapp.healthStatus") } },
            [
              _vm.isHealthy
                ? _c("a-badge", {
                    attrs: {
                      status: "success",
                      text: _vm.$t("whatsapp.healthy"),
                    },
                  })
                : _c("a-badge", {
                    attrs: {
                      status: "error",
                      text: _vm.$t("whatsapp.notHealthy"),
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: _vm.$t("whatsapp.whatsappName") } },
            [_vm._v(_vm._s(_vm.getVerifiedName()))]
          ),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: _vm.$t("whatsapp.whatsappNumber"), span: 3 } },
            [_vm._v(" " + _vm._s(_vm.getPhoneNumber()))]
          ),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: _vm.$t("whatsapp.actions"), span: 4 } },
            [
              _c("div", { staticClass: "debug-buttons-container" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("getMe")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.getMe")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("getConnectionState")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("whatsapp.getConnectionState")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("getHostNumber")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.getHostNumber")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("getStatus")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.getStatus")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("kill")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.kill")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("reset")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.reset")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("refresh")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.refresh")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("syncContacts")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.syncContacts")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("getWAVersion")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.waVersion")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("healthCheck")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.healthCheck")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("gc")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("whatsapp.runGc")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", ghost: "" },
                        on: {
                          click: function ($event) {
                            return _vm.sendRequest("emitUnreadMessages")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("whatsapp.getUnreadMessages")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "response" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("whatsapp.response"))),
                  ]),
                  _vm._v(" "),
                  _vm.busy
                    ? _c("span", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.$t("whatsapp.waiting"))),
                      ])
                    : _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("prism-editor", {
                            staticClass: "my-editor",
                            attrs: { highlight: _vm.highlighter, readonly: "" },
                            model: {
                              value: _vm.response,
                              callback: function ($$v) {
                                _vm.response = $$v
                              },
                              expression: "response",
                            },
                          }),
                        ],
                        1
                      ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }